<template>
    <component v-if="itemDefinition" v-bind:is="itemDefinition.viewType" v-bind:itemDefinition="itemDefinition"></component>
</template>

<script>
    import PlotList from "./automated/PlotList";
    import {mapGetters} from 'vuex'

    export default {
        name: 'CustomViewRenderer',
        components: {PlotList},
        computed: {
            ...mapGetters([
                'publishedCustomViews',
            ]),
            itemDefinition() {
                for (let item of this.publishedCustomViews){
                    if(item.id===this.$route.params.id){
                        return item
                    }
                }
                return null
            },
        }
    }
</script>
